import modules from "../../../secrets-web/src/store/reducers/modules/index";
import auth from "./auth";

export default {
  ...modules,
  auth,
}